<!--高级版批量发起-->
<template>
  <!--批量发起弹窗-->
  <div>
    <el-dialog
      title="批量发起"
      class="myDialog"
      :visible.sync="plDialogVisible"
      :close-on-click-modal="false"
      @open="openDialog"
      @close="closeDialog"
    >
      <div style="margin-bottom: 20px">
        <img
          src="../../static/images/warning.png"
          style="width: 15px; height: 15px; margin-right: 5px"
        />
        <span style="font-size: 14px; color: #290202"
          >下载Excel模板，录入模板变量信息后，上传该Excel批量发起多份合同。</span
        >
      </div>
      <div style="margin-bottom: 40px">
        <img
          src="../../static/images/warning.png"
          style="width: 15px; height: 15px; margin-right: 5px"
        />
        <span style="font-size: 14px; color: #290202"
          >如需多个模板同时发起，请前往首页发起合同页面。</span
        >
      </div>
      <div class="con">
        <el-steps direction="vertical" :active="plStep">
          <el-step>
            <span v-if="+plStep > 0" slot="icon" class="el-icon-success"></span>
            <template slot="title">
              <p>下载批量发起模板</p>
              <p>
                <a
                  v-if="isInDingTalk"
                  class="btn"
                  href="javascript: void(0)"
                  @click="
                    apiMethods.TemplateController.download_down_ding(tplId)
                  "
                  >点击下载</a
                >
                <a
                  v-else
                  class="btn"
                  href="javascript: void(0)"
                  @click="apiMethods.TemplateController.download_down(tplId)"
                  >点击下载</a
                >
              </p>
            </template>
          </el-step>
          <el-step>
            <span v-if="+plStep > 1" slot="icon" class="el-icon-success"></span>
            <template slot="title">
              <p>整理表格<span>/ 根据下载的模板，编辑相关信息</span></p>
            </template>
          </el-step>
          <el-step>
            <span v-if="+plStep > 2" slot="icon" class="el-icon-success"></span>
            <template slot="title">
              <p>选择并上传<span>/ 上传修改好的EXCEL表格</span></p>
              <p class="myMsg">
                <a
                  class="btn"
                  @click="$refs['fileInput'].click()"
                  v-if="isInDingTalk"
                  >选择文件<input
                    class="fileInput"
                    @change="fileUpload($event, 1)"
                    type="file"
                    ref="fileInput"
                /></a>
                <a v-else class="btn" @click="$refs['fileInput0'].click()"
                  >选择文件<input
                    class="fileInput"
                    @change="fileUpload($event, 0)"
                    type="file"
                    ref="fileInput0"
                /></a>
                <!--上传失败行-->
                <template v-if="fqParam.failList.length">
                  <span style="color: #ff8800; font-size: 14px"
                    ><span class="el-icon-warning"></span>
                    模板填写错误:
                    <div class="nom">
                      <template v-for="(item, index) in fqParam.failList">
                        <span :key="index" style="display: block"
                          >第{{ item.number }}行错误：{{
                            item.failString
                          }}</span
                        >
                      </template>
                    </div>
                  </span>
                </template>
                <template v-else>
                  <!--上传后展示-->
                  <span
                    v-if="fqParam.upStatus === 1"
                    style="color: #00cb14; font-size: 14px"
                    ><span
                      style="color: #00cb14; font-size: 14px"
                      class="el-icon-success"
                    ></span
                    >上传成功！将同时发起{{
                      fqParam.failList.length +
                      fqParam.icommonTemplateDTOs.length
                    }}份合同</span
                  >
                  <span
                    v-if="fqParam.upStatus === 0 && !fqParam.failList.length"
                    style="color: #ff8800; font-size: 14px"
                    ><span class="el-icon-warning"></span
                    >上传失败，请重新选择并上传</span
                  >
                </template>
              </p>
            </template>
          </el-step>
        </el-steps>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="width: 80px" @click="plDialogVisible = false"
          >取消</el-button
        >
        <el-button style="width: 80px" type="primary" @click="plFq"
          >立即发起</el-button
        >
      </div>
    </el-dialog>
    <!--消费弹窗-->
    <el-dialog
      :visible.sync="priseVisibleDialog"
      @closed="handleDelSendContract"
      title="温馨提示"
      :show-close="false"
      width="400px"
      class="prise-dialog"
    >
      <div
        class="box-dashed text-center"
        style="margin-top: 10px; padding-bottom: 5px"
      >
        <img src="/images/icon_signed.png" style="height: 80px" />
        <template v-if="priseInfo.mealInfo">
          <h4>
            本次共花费：
            <span class="color-danger">{{ priseInfo.mealInfo }}</span>
          </h4>
          <h4 v-if="priseInfo.point">
            另需要支付<span class="color-danger"
              >{{ priseInfo.point }}积分</span
            >
          </h4>
        </template>
        <h4 v-else style="font-weight: bold">
          本次共花费：<span class="color-danger"
            >{{ priseInfo.point }}积分</span
          >
        </h4>
        <p style="text-align: start; margin-left: 8px">
          <i class="el-icon-info"></i>
          发起后，签署方将收到签署短信通知，该通知72小时有效，请尽快完成签署！
        </p>
      </div>
      <div slot="footer" class="text-center">
        <el-button
          @click="toPay(priseInfo.cashierUrl)"
          type="danger"
          size="small"
          class="footer-btn"
          :disabled="payDisabled"
          >确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ApiMethods,
  postCreateApply,
  configUrl
} from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { isInDingTalk } from "../../assets/js/utils/ding-env";

export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    tplId: {
      // 模板id
      type: Number,
      default: null
    },
    nowToken: {
      // 临时token
      type: String,
      default: null
    }
  },
  data () {
    return {
      isInDingTalk,
      apiMethods: ApiMethods,
      plDialogVisible: false,
      plStep: -1,
      fqParam: {
        upStatus: -1, // 上传状态 1 成功 0 失败
        failList: [], // // 发起失败条数
        icommonTemplateDTOs: [], // 发起成功条数
        attatchFileNamesJson: [] // 模板附件
      },
      payDisabled: false,

      // ..........支付相关 start..........
      // 显示价格的弹窗
      priseInfo: { mealInfo: null, money: 0, point: 0, cashierUrl: "" },
      priseVisibleDialog: false,
      payInfoData: {}
      // ..........支付相关 end............
    };
  },
  computed: {
    // 是否集团
    isGroup () {
      let v = this.$store.getters.currentAuthUser;
      if (v && v.corpUserId) {
        return true;
      }
      return false;
    }
  },
  methods: {
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    openDialog () {
      this.$emit("update:show", true);
    },
    closeDialog () {
      this.$emit("update:show", false);
    },
    /** 文件上传
     * @param type 0 saas 1 钉钉
     */
    fileUpload (e, type) {
      // 清空变量
      this.fqParam = {
        upStatus: -1, // 上传状态 1 成功 0 失败
        failList: [], // // 发起失败条数
        icommonTemplateDTOs: [], // 发起成功条数
        attatchFileNamesJson: [] // 模板附件
      };

      let file = e.target.files[0] || e.value;
      // let re = new RegExp('(.xlsx|.xls)$', 'i');
      let reg = new RegExp("(.xls)$", "i");

      if (!reg.test(file.name)) {
        e.target.value = "";
        return this.$message.warning("请上传.xls格式的excel文件");
      }

      if (file.size > 1024 * 1024 * 3) {
        e.target.value = "";
        return this.$message.warning("文件大小不能超过3M");
      }

      this.loadingStart("文件上传中");
      // const uploadV = isInDingTalk ? 'uploadBatch_ding' : 'uploadBatch';
      const uploadV = type === 1 ? 'uploadBatch_ding' : 'uploadBatch';
      ApiMethods.FileOperController[uploadV]({
        file: file,
        tplId: this.tplId
      })
        .then(data => {
          e.target.value = "";
          this.loadingClose();
          console.log("上传模板：", data);
          data = data.data;
          this.fqParam = {
            ...data,
            upStatus: 1
          };
        })
        .catch(err => {
          e.target.value = "";
          this.fqParam.upStatus = 0;
          this.loadingClose();
          this.$message.warning(err.description || "文件上传失败");
        });
    },

    /**
     *  批量发起
     * */
    plFq () {
      // 有一行是失败都不能发起
      if (
        !this.fqParam.icommonTemplateDTOs.length ||
        this.fqParam.failList.length > 0
      )
        return this.$message.warning("请先上传批量发起模板");
      this.loadingStart("批量发起中...");

      if (this.fqParam.icommonTemplateDTOs) {
        this.fqParam.icommonTemplateDTOs.forEach(contract => {
          if (contract.signers) {
            contract.signers.forEach(signer => {
              //高级模板个人使用手写
              signer.handSign =
                parseInt(signer.signatoryUserType) === 0 ? 1 : 2;
            });
          }
        });
      }

      let param = {
        ifOrder: this.fqParam.orderFlag, // 是否顺序签字
        contractId: this.fqParam.contractId,
        contractName: this.fqParam.contractName,
        attatchFileNamesJson: JSON.stringify(this.fqParam.attatchFileNamesJson),
        varsWrapperJson: JSON.stringify(this.fqParam.icommonTemplateDTOs),
        tplId: this.tplId,
        noConvert: 1, // 当为高级模板时才传，1不转换为图片，若要预览就传其他的
        returnURL: "",
        pay: 1,
        consumMode: 0,
        needVideoSign: 0, // 是否使用视频签署 1=启用
        serverCa: 1, // 是否云证书
        needCa: 0, // 硬key证书
        overDate: "",
        applyId: null,
        needQifengSign: 1,
        approveJson: [], // 集团账号审核人数组json [集团登录账号] 联系人corpUserIdSec字段
        carbonCopyJson: [], // 集团账号抄送人数组json [集团登录账号] 联系人corpUserIdSec字段
      };
      //临时ct成员token
      if(this.nowToken) param._ctToken = this.nowToken;
      // if (isInDingTalk) param.needPresSign = 0
      if (isInDingTalk) param.needPresSign = 0

      if (!this.isGroup) {
        param.returnURL =
          configUrl().junziqianWebOp + "/signInfo/applyList?match=-1";
      } else {
        param.returnURL =
          configUrl().junziqianWebOp + "/signInfo/signList?signStatus=2";
      }
      ApiMethods.TemplateController.batchCreateTpl2(param)
        .then(res => {
          this.loadingClose();
          if (res.success) {
            if (this.isGroup || this.nowToken) {
              this.createdFinish(res.data, false);
            } else {
              this.createdFinish(data, false, false, param);
            }
          } else {
            this.$message.error(res.description || this.$tip);
          }
        })
        .catch(err => {
          console.log(22222222)
          this.loadingClose();
          this.$message.warning(err.description || this.$tip);
        });
    },
    // 发起完成之后回掉函数
    createdFinish (data, saveToDraftBox, batch, param) {
      const snapshotId = data.snapshotId || "";
      this.payInfoData = {
        batch: batch,
        param: param,
        recharge: data.recharge,
        snapshotId: snapshotId
      };
      this.loadingClose();

      if (!data.needPay || data.needPay === "false") {
        this.$message.success("发起签署成功");
        if (this.isGroup) {
          if (saveToDraftBox) {
            this.$router.push({
              path:
                "/corp/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
            });
          } else {
            this.$router.push({
              path: "/corp/signInfo/applyList?match=-1&snapshotId=" + snapshotId
            });
          }
        } else {
          if (saveToDraftBox) {
            this.$router.push({
              path: "/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
            });
          } else {
            this.$router.push({
              path: "/signInfo/applyList?match=-1&snapshotId=" + snapshotId
            });
          }
        }
      } else {
        if (this.payInfoData.recharge) {
          this.$jzqService.pointRechargeTip({_ctToken: this.nowToken}); // 积分不足时的充值提示
        } else {
          this.priseInfo.cashierUrl = data.cashierUrl || "";
          // this.priseInfo.money = data.money;
          this.priseInfo.point = data.point;
          this.priseVisibleDialog = true;
          var moneyData = data.moneyData || false;
          if (moneyData) {
            var moneryArr = [];
            // 签署次数
            if (moneyData.applySign && moneyData.applySign.timesPackage) {
              moneryArr.push(`签署${moneyData.applySign.timesPackage}次`);
            }
            // 银行卡4要数次数
            if (moneyData.bankFour && moneyData.bankFour.timesPackage) {
              moneryArr.push(`四要素${moneyData.bankFour.timesPackage}次`);
            }
            // 3要数次数
            if (moneyData.bankThree && moneyData.bankThree.timesPackage) {
              moneryArr.push(`三要素${moneyData.bankThree.timesPackage}次`);
            }
            // 人脸次数
            if (moneyData.face && moneyData.face.timesPackage) {
              moneryArr.push(`人脸${moneyData.face.timesPackage}次`);
            }
            if (moneryArr && moneryArr.length > 0) {
              this.priseInfo.mealInfo = moneryArr.join("；");
            }
          }
        }
      }
    },
    // 。。。。。。。。。。。。。。。。。。消费相关 start。。。。。。。。。。。。。。
    // 取消合同发起或保存
    handleDelSendContract () { },
    // 前往支付
    toPay () {
      this.payDisabled = true;
      const param = Object.assign(this.payInfoData.param, { pay: 1 });
      if (this.payInfoData.batch) {
        ApiCorpMethods.BatchContractController.batchCreate({...param, _ctToken: this.nowToken}).then(res => {
          if (+res.code === 10806) {
            this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            this.payDisabled = false;
            return;
          }
          if (+res.code === 0) {
            this.$message.success("发起签署成功");
            if (this.isGroup) {
              this.$router.push({
                path:
                  "/corp/signInfo/applyList?match=-1&snapshotId=" +
                  this.payInfoData.snapshotId
              });
            } else {
              this.$router.push({
                path:
                  "/signInfo/applyList?match=-1&snapshotId=" +
                  this.payInfoData.snapshotId
              });
            }
            return;
          }
          this.$message.error(res.description || "支付失败");
          this.payDisabled = false;
        });
      } else {
        postCreateApply({...param, _ctToken: this.nowToken})
          .then(res => {
            if (+res.code === 0) {
              this.$message.success("发起签署成功");
              if (this.isGroup) {
                this.$router.push({
                  path:
                    "/corp/signInfo/applyList?match=-1&snapshotId=" +
                    this.payInfoData.snapshotId
                });
              } else {
                this.$router.push({
                  path:
                    "/signInfo/applyList?match=-1&snapshotId=" +
                    this.payInfoData.snapshotId
                });
              }
              return;
            }
            if (+res.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
              this.payDisabled = false;
            }
            this.$message.error(res.description || "支付失败");
            this.payDisabled = false;
          })
          .catch(err => {
            if (+err.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            }
            this.payDisabled = false;
          });
      }
    }
    // 。。。。。。。。。。。。。。。。。。消费相关 end。。。。。。。。。。。。。。.
  },
  created () {
    this.plDialogVisible = this.show;
  },
  watch: {
    show (newVal) {
      this.plDialogVisible = newVal;
    }
  },
  name: "batchLaunch"
};
</script>

<style lang="less" scoped>
.btn {
  position: relative;
}

.fileInput {
  display: none;
}

.myDialog {
  /deep/ .el-dialog {
    width: 600px;
  }
  /deep/ .el-dialog__header {
    line-height: 40px;
  }
  /deep/ .el-dialog__title {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #290202;
  }
  /deep/ .el-dialog__body {
    min-height: 160px;
    box-sizing: border-box;
    padding: 20px 10px 50px 70px;
  }
  /deep/ .el-dialog__footer {
    padding-bottom: 15px;
  }
  .con {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #290202;
    p {
      color: rgba(41, 2, 2, 1);
      text-align: left;
      margin-bottom: 5px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      span {
        font-size: 12px;
        font-family: PingFang SC;
        line-height: 17px;
        color: #290202;
        font-weight: normal;
        /*margin-left: 10px;*/
      }
      .el-icon-warning {
        color: #ff8800;
        font-size: 14px;
      }
    }
    a.btn {
      width: 100px;
      height: 25px;
      line-height: 25px;
      display: inline-block;
      background: #ec1c1c;
      opacity: 1;
      border-radius: 2px;
      text-align: center;
      color: #ffffff;
      font-weight: bold;
      font-size: 14px;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        color: #fff;
        opacity: 1;
        background-color: rgba(236, 28, 28, 0.7);
        border-color: rgba(236, 28, 28, 0.7);
      }
    }
  }

  .el-button {
    font-size: 14px;
    padding: 0;
    width: 75px;
    line-height: 30px;
  }
  .el-button--primary {
    &.is-disabled {
      color: #fff;
      opacity: 1;
      background-color: rgba(236, 28, 28, 0.7);
      border-color: rgba(236, 28, 28, 0.7);
    }
  }
  .myMsg {
    padding-left: 120px;
    box-sizing: border-box;
    position: relative;
    .btn {
      position: absolute;
      left: 0;
      top: 0;
    }
    span {
      margin-left: 0;
    }

    .nom {
      overflow-y: auto;
      max-height: 100px;
    }
  }
}

/*步骤条*/
/deep/ .el-steps {
  .el-step {
    min-height: 92px;
  }

  .el-step__line {
    background: rgba(220, 220, 220, 1);
    top: 1px;
  }

  .el-icon-success {
    color: #ec1c1c;
    font-size: 25px;
  }

  .el-step__head.is-finish {
    border-color: #ec1c1c;
  }

  .el-step__icon-inner {
    color: #ffffff;
    font-size: 14px;
  }

  .is-text {
    background: #dcdcdc;
    border-radius: 50%;
    border-color: #dcdcdc;
  }

  .is-finish .is-text {
    border: none;
    background: #ffffff;
  }

  .is-process .is-text {
    background: #ec1c1c;
    border-color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// components/advancedVersion/batchLaunch.vue